import { PageTemplate, HeaderTemplate, Button } from "../styles";
import Form from "react-bootstrap/Form";
import styled from "styled-components";
import { dataRequest } from "../api/user";
import toast from "react-hot-toast";
import { useState } from "react";
import { SuccessIcon } from "../svgs";

const SupportStyles = styled.div`
  label {
    padding: 10px 30px;
    font-weight: 700;
  }
  textarea {
    margin-bottom: 20px;
  }
  button {
    margin: 0 auto;
    padding: 8px 40px;
  }
`;

const DataRequest = () => {
  const [formSubmitted, setFormSubmitted] = useState(false);

  const handleDataRequestSubmit = async (e) => {
    e.preventDefault();
    const message = e.target.message.value;
    const email = e.target.email.value;
    const response = await dataRequest({ message, email });
    if (response.status === 200) {
      setFormSubmitted(true);
    } else {
      toast.error("Form Submission Failed");
    }
  };

  return (
    <SupportStyles>
      <HeaderTemplate className="narrow">
        <div className="header flex-header">
          <div className="title">
            <h1>Data Request Form</h1>
          </div>
        </div>
      </HeaderTemplate>
      <PageTemplate className="narrow">
        {formSubmitted ? (
          <div className="content-page">
            <SuccessIcon className="centered-icon" />
            <h2 className="center">Form Submitted Successfully</h2>
          </div>
        ) : (
          <form className="content-page-form" onSubmit={(e) => handleDataRequestSubmit(e)}>
            <Form.Group className="form-group">
              <Form.Control placeholder="Email Address" type="text" name="email" id="email" />
              <Form.Control placeholder="Let us know how we can help!" as="textarea" name="message" rows={10} />
            </Form.Group>
            <Button type="submit">submit</Button>
          </form>
        )}
      </PageTemplate>
    </SupportStyles>
  );
};

export default DataRequest;
